module.exports = __webpack_public_path__ + "media/images/front/common/noticeIcon-be8eb00b96da93dcc29b3863cb61989d.png";